package com.example.mystybag.login.model

// No specific state needed for now, just a simple success screen
data class MerchantRegistrationSuccessUIState(
    val dummy: Boolean = true // Data class must have at least one parameter
)
